var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Image, Grid, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReactImageVideoLightbox from './ReactImageVideoLightbox';
var $ = window.$;
var PdfIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/pdf.png";
var DocIcon = 'http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/doc.png';
var PptIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/powerpoint.png";
var ExcelIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/excel.png";

var imagesType = ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF', 'webp'];
var pdfType = ['pdf', 'PDF'];
var docType = ['doc', 'docx'];
var pptType = ['ppt', 'pptx'];
var excelType = ['xlx', 'xlsx'];

var Images = (_temp = _class = function (_Component) {
  _inherits(Images, _Component);

  function Images(props) {
    _classCallCheck(this, Images);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      modal: false,
      countFrom: props.countFrom > 0 && props.countFrom < 5 ? props.countFrom : 5,
      conditionalRender: false
    };

    _this.openModal = _this.openModal.bind(_this);
    // this.onClose = this.onClose.bind(this);

    if (props.countFrom <= 0 || props.countFrom > 5) {
      console.warn('countFrom is limited to 5!');
    }
    return _this;
  }

  Images.prototype.openModal = function openModal(index) {
    var _props = this.props,
        onClickEach = _props.onClickEach,
        images = _props.images;

    console.log("images[index]", images);
    if (onClickEach) {
      return onClickEach({ src: images[index], index: index });
    }

    this.setState({ modal: true, url: images[index], index: index });
    $("#post").modal("toggle");
  };

  Images.prototype.onClose = function onClose() {
    this.setState({ modal: false });
    // $("#post").modal("toggle");
    // $(".modal").modal("hide");
  };

  Images.prototype.renderOne = function renderOne() {
    var images = this.props.images;
    var countFrom = this.state.countFrom;

    var overlay = images.length > countFrom && countFrom == 1 ? this.renderCountOverlay(true) : this.renderOverlay();

    return React.createElement(
      Grid,
      null,
      React.createElement(
        Row,
        null,
        imagesType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 12, md: 12, className: 'border height-one background ball', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + images[0] + ')' } },
          overlay
        ) : pdfType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 12, md: 12, className: 'border height-one background ball', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 12, md: 12, className: 'border height-one background ball', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 12, md: 12, className: 'border height-one background ball', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 12, md: 12, className: 'border height-one background ball', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { onClick: this.openModal.bind(this, 0), style: { width: '100%' } },
          React.createElement('video', { controls: true, src: images[0], className: 'border background TopVideo', style: { width: '100%' } })
        )
      )
    );
  };

  Images.prototype.renderTwo = function renderTwo() {
    var images = this.props.images;
    var countFrom = this.state.countFrom;

    var overlay = images.length > countFrom && [2, 3].includes(+countFrom) ? this.renderCountOverlay(true) : this.renderOverlay();
    var conditionalRender = [3, 4].includes(images.length) || images.length > +countFrom && [3, 4].includes(+countFrom);

    return React.createElement(
      Grid,
      null,
      React.createElement(
        Row,
        null,
        conditionalRender ?
        //1st conditionalRender true
        imagesType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + images[1] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background videoTag', onClick: this.openModal.bind(this, 1) },
          React.createElement('video', { controls: true, src: images[1], className: 'border background videoFirst' })
        ) :
        //1st conditionalRender false
        imagesType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + images[0] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[0].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 0), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background videoTag', onClick: this.openModal.bind(this, 0) },
          React.createElement('video', { controls: true, src: images[0], className: 'border background videoFirst' })
        ),
        conditionalRender ?
        //2nd conditionalRender true
        imagesType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + images[2] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background videoTag', onClick: this.openModal.bind(this, 2) },
          React.createElement('video', { controls: true, src: images[2], className: 'border background videoFirst' })
        ) :
        //2nd conditionalRender false
        imagesType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + images[1] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background newPad', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { xs: 6, md: 6, className: 'border height-two background videoTag', onClick: this.openModal.bind(this, 1) },
          React.createElement('video', { controls: true, src: images[1], className: 'border background videoFirst' })
        )
      )
    );
  };

  Images.prototype.renderThree = function renderThree(more) {
    var images = this.props.images;
    var countFrom = this.state.countFrom;

    var conditionalRender = images.length == 4 || images.length > +countFrom && +countFrom == 4;
    var overlay = !countFrom || countFrom > 5 || images.length > countFrom && [4, 5].includes(+countFrom) ? this.renderCountOverlay(true) : this.renderOverlay(conditionalRender ? 3 : 4);

    return React.createElement(
      Grid,
      null,
      React.createElement(
        Row,
        null,
        conditionalRender ?
        //3rd conditionalRender true
        imagesType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 1), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[1] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PdfIcon + ')' } },
          this.renderOverlay()
        ) : docType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + DocIcon + ')' } },
          this.renderOverlay()
        ) : pptType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + PptIcon + ')' } },
          this.renderOverlay()
        ) : excelType.filter(function (item) {
          return item === images[1].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 1), style: { background: 'url(' + ExcelIcon + ')' } },
          this.renderOverlay()
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 1), style: { padding: 1 } },
          React.createElement(
            'video',
            { controls: true, src: images[1], className: 'border background videoTagThree' },
            ' ',
            this.renderOverlay()
          )
        ) :
        //3rd conditionalRender false
        imagesType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[2] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PdfIcon + ')' } },
          this.renderOverlay()
        ) : docType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + DocIcon + ')' } },
          this.renderOverlay()
        ) : pptType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PptIcon + ')' } },
          this.renderOverlay()
        ) : excelType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + ExcelIcon + ')' } },
          this.renderOverlay()
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 2), style: { padding: 1 } },
          React.createElement(
            'video',
            { controls: true, src: images[2], className: 'border background videoTagThree' },
            ' ',
            this.renderOverlay()
          )
        ),
        conditionalRender ?
        //3rd conditionalRender true

        imagesType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[2] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PdfIcon + ')' } },
          this.renderOverlay()
        ) : docType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + DocIcon + ')' } },
          this.renderOverlay()
        ) : pptType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + PptIcon + ')' } },
          this.renderOverlay()
        ) : excelType.filter(function (item) {
          return item === images[2].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 2), style: { background: 'url(' + ExcelIcon + ')' } },
          this.renderOverlay()
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 2), style: { padding: 1 } },
          React.createElement(
            'video',
            { controls: true, src: images[2], className: 'border background videoTagThree' },
            ' ',
            this.renderOverlay()
          )
        ) :
        //3rd conditionalRender false
        imagesType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[3] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + PdfIcon + ')' } },
          this.renderOverlay()
        ) : docType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + DocIcon + ')' } },
          this.renderOverlay()
        ) : pptType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + PptIcon + ')' } },
          this.renderOverlay()
        ) : excelType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + ExcelIcon + ')' } },
          this.renderOverlay()
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 3), style: { padding: 1 } },
          React.createElement(
            'video',
            { controls: true, src: images[3], className: 'border background videoTagThree' },
            ' ',
            this.renderOverlay()
          )
        ),
        conditionalRender ?
        //3rd conditionalRender true
        imagesType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[3] + ')' } },
          this.renderOverlay()
        ) : pdfType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + PdfIcon + ')' } },
          this.renderOverlay()
        ) : docType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + DocIcon + ')' } },
          this.renderOverlay()
        ) : pptType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + PptIcon + ')' } },
          this.renderOverlay()
        ) : excelType.filter(function (item) {
          return item === images[3].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 3), style: { background: 'url(' + ExcelIcon + ')' } },
          this.renderOverlay()
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 3), style: { padding: 1 } },
          React.createElement(
            'video',
            { controls: true, src: images[3], className: 'border background videoTagThree' },
            ' ',
            this.renderOverlay()
          )
        ) :
        //3rd conditionalRender false
        imagesType.filter(function (item) {
          return item === images[4].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 4), style: { padding: '40% !important', color: '#fff', background: 'url(' + images[4] + ')' } },
          overlay
        ) : pdfType.filter(function (item) {
          return item === images[4].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 4), style: { background: 'url(' + PdfIcon + ')' } },
          overlay
        ) : docType.filter(function (item) {
          return item === images[4].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 4), style: { background: 'url(' + DocIcon + ')' } },
          overlay
        ) : pptType.filter(function (item) {
          return item === images[4].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 4), style: { background: 'url(' + PptIcon + ')' } },
          overlay
        ) : excelType.filter(function (item) {
          return item === images[4].split('.').pop();
        }).length > 0 ? React.createElement(
          Col,
          { xs: 6, md: 4, className: 'border height-three background marginThree', onClick: this.openModal.bind(this, 4), style: { background: 'url(' + ExcelIcon + ')' } },
          overlay
        ) : React.createElement(
          Col,
          { xs: 6, md: 4, onClick: this.openModal.bind(this, 4), style: { padding: 1 } },
          React.createElement('video', { controls: true, src: images[4], className: 'border background videoTagThree' }),
          overlay
        )
      )
    );
  };

  Images.prototype.renderOverlay = function renderOverlay(id) {
    var _props2 = this.props,
        hideOverlay = _props2.hideOverlay,
        renderOverlay = _props2.renderOverlay,
        overlayBackgroundColor = _props2.overlayBackgroundColor;


    if (hideOverlay) {
      return false;
    }

    return [React.createElement('div', { key: 'cover-' + id, className: 'cover slide', style: { backgroundColor: overlayBackgroundColor } }), React.createElement(
      'div',
      { key: 'cover-text-' + id, className: 'cover-text slide animate-text', style: { fontSize: '100%' } },
      renderOverlay()
    )];
  };

  Images.prototype.renderCountOverlay = function renderCountOverlay(more) {
    var images = this.props.images;
    var countFrom = this.state.countFrom;

    var extra = images.length - (countFrom && countFrom > 5 ? 5 : countFrom);

    return [more && React.createElement('div', { key: 'count', className: this.props.images[4] ? this.props.images[4].split('.').pop() == 'mp4' ? "coverImg" : "cover" : "cover" }), more && React.createElement(
      'div',
      { key: 'count-sub', className: 'cover-text', style: { fontSize: '200%' } },
      React.createElement(
        'p',
        null,
        '+',
        extra
      )
    )];
  };

  Images.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        modal = _state.modal,
        index = _state.index,
        countFrom = _state.countFrom;
    var images = this.props.images;

    var imagesToShow = [].concat(images);

    if (countFrom && images.length > countFrom) {
      imagesToShow.length = countFrom;
    }

    return React.createElement(
      'div',
      { className: 'grid-container' },
      [1, 3, 4].includes(imagesToShow.length) && this.renderOne(),
      imagesToShow.length >= 2 && imagesToShow.length != 4 && this.renderTwo(),
      imagesToShow.length >= 4 && this.renderThree(),
      modal && React.createElement(
        'div',
        { className: 'modalImgBox', id: 'post' },
        React.createElement(ReactImageVideoLightbox, {
          data: this.props.images,
          startIndex: index,
          showResourceCount: true,
          onCloseCallback: function onCloseCallback() {
            _this2.onClose();
          } })
      )
    );
  };

  return Images;
}(Component), _class.defaultProps = {
  images: [],
  hideOverlay: false,
  renderOverlay: function renderOverlay() {
    return 'Preview';
  },
  overlayBackgroundColor: '#222222',
  onClickEach: null,
  countFrom: 5
}, _temp);


Images.propTypes = process.env.NODE_ENV !== "production" ? {
  images: PropTypes.array.isRequired,
  hideOverlay: PropTypes.bool,
  renderOverlay: PropTypes.func,
  overlayBackgroundColor: PropTypes.string,
  onClickEach: PropTypes.func,
  countFrom: PropTypes.number
} : {};

export default Images;